"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledInlineText = exports.StyledText = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _Theme = require("../../Theme/Theme.spacing");

var _Theme2 = require("../../Theme/Theme.variables");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n          text-align: center;\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  /* font */\n  font-family: ", ";\n  \n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n\n  ", " /* default spacing */\n  margin: 0;\n  padding: 0;\n\n  /* spacing module */\n  ", ";\n\n  /* color */\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // import theme components


var generic = (0, _styledComponents.css)(_templateObject(), function (props) {
  return (0, _Theme2.variables)(props).fontBody;
}, function (props) {
  return props.size === 'lg' && "\n    font-size: ".concat((0, _Theme2.variables)(props).fontSizeLg, "px;\n    letter-spacing: ").concat((0, _Theme2.variables)(props).letterSpacing.body[1], ";\n    line-height: 1.3;\n  ");
}, function (props) {
  return props.size === 'default' && "\n    font-size: ".concat((0, _Theme2.variables)(props).fontSizeBase, "px;\n    letter-spacing: ").concat((0, _Theme2.variables)(props).letterSpacing.body[1], ";\n    line-height: ").concat((0, _Theme2.variables)(props).fontBaseLineHeight, ";\n  ");
}, function (props) {
  return props.size === 'sm' && "\n    font-size: ".concat((0, _Theme2.variables)(props).fontSizeSm, "px;\n    letter-spacing: ").concat((0, _Theme2.variables)(props).letterSpacing.body[2], ";\n    line-height: 1.6;\n  ");
}, function (props) {
  return props.size === 'xs' && "\n    font-size: ".concat((0, _Theme2.variables)(props).fontSizeXs, "px;\n    letter-spacing: ").concat((0, _Theme2.variables)(props).letterSpacing.body[3], ";\n    line-height: 1.66;\n  ");
}, function (props) {
  return props.small && "font-size: ".concat((0, _Theme2.variables)(props).fontSizeSm, "px;");
}, function (props) {
  return props.center ? (0, _styledComponents.css)(_templateObject2()) : undefined;
}, function (props) {
  return (0, _Theme.spacing)(props);
}, function (props) {
  return props.textColor && (0, _styledComponents.css)(_templateObject3(), (0, _Theme2.variables)(props)[props.textColor]);
});

var StyledText = _styledComponents.default.p(_templateObject4(), generic, _styledSystem.space);

exports.StyledText = StyledText;

var StyledInlineText = _styledComponents.default.span(_templateObject5(), generic, _styledSystem.space);

exports.StyledInlineText = StyledInlineText;